import { FunctionComponent, useState } from 'react';
import './SmartTagMenu.scss'

import { useRichTextEditorContext } from 'mui-tiptap';

import type { IMenuItem } from '@dw/models/shared';
import { FormSelectInput, Form, InformationalWrapper } from '@dw/components/core';
import { componentClassName } from '@dw/utils';

interface ISmartTagForm {
  smartTag: string;
}
const initFormData = (): ISmartTagForm => ({
  smartTag: ''
});

interface ISmartTagMenuProps {
  options: IMenuItem[];
  label?: string;
}
export const SmartTagMenu: FunctionComponent<ISmartTagMenuProps> = (props: ISmartTagMenuProps) => {

  const {
    options,
    label = "Insert Placeholder",
  } = props;

  const editor = useRichTextEditorContext();

  const [formData, setFormData] = useState(initFormData());

  if (!editor) return null;

  const handleFormDataChanged = (newFormData: ISmartTagForm) => {

    setFormData(initFormData());

    const targetOption = options.find(x => x.value === newFormData.smartTag);
    if (!targetOption) return;

    editor.commands.insertSmartTag({ ...targetOption });
  }

  const cn = componentClassName('rte-smart-tag-menu');

  return (
    <InformationalWrapper tooltip='Choose from a list of placeholders (e.g. First Name, Studio Name) that will be replaced with real values later' className={cn()}>
      <Form<ISmartTagForm>
        formData={formData}
        formDataChanged={handleFormDataChanged}
      >
        <FormSelectInput<ISmartTagForm>
          name="smartTag"
          label={label}
          options={options}
          size="small"
          margin='none'
        />
      </Form>
    </InformationalWrapper>
  );
};
